/** Explore header search prompts. */
export const EXPLORE_SEARCH_PLACEHOLDERS = [
  "Search people...",
  "Search churches...",
  "Search ministries...",
  "Search a city...",
  "Find events near you...",
  "Connect with like-minded believers...",
  "Find missions partners...",
  "Expand your network...",
];

/** Inbox search prompts (header + message dock). */
export const INBOX_SEARCH_PLACEHOLDERS = [
  "Search chats...",
  "Search messages...",
  "Find a conversation...",
  "Search by person...",
  "Jump to a message...",
];

/** How long each placeholder stays visible before rotating. */
export const SEARCH_PLACEHOLDER_ROTATE_MS = 3000;
